import { Link, Stack, styled } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const WrapperStack = styled(Stack)(({ theme }) => ({
    width: '100%',
    height: '100%',
    maxWidth: theme.fixed.errorPage.maxWidth,
    margin: '0 auto',
    padding: theme.spacing(5),
}));

const Title = styled('h1')(({ theme }) => ({
    ...theme.typography.title1,
    marginBottom: theme.spacing(5),
    marginTop: 0,
}));

const Subtitle = styled('h2')(({ theme }) => ({
    ...theme.typography.large,
    whiteSpace: 'pre-line',
    textAlign: 'center',
}));

export const Error403 = () => {
    const { t } = useTranslation();

    return (
        <WrapperStack alignItems="center" justifyContent="center">
            <Title>{t('403.title')}</Title>
            <Subtitle>
                {/* t('403.subtitle') */}
                <Trans
                    i18nKey="403.subtitle"
                    components={{
                        redirectLink: (
                            <Link
                                color="secondary.dark"
                                href="https://supporthub.tx.group/esc?id=sc_cat_item&sys_id=de3472ec1bb049d0ac8e21f5604bcb59"
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        ),
                    }}
                />
            </Subtitle>
        </WrapperStack>
    );
};
